<template>
  <section class="form-underwriting width-700">
    <el-form
      ref="form"
      :rules="rules"
      class="form-container"
      :model="formData">
      <div class="form-item form-half">
        <span>Policy Type</span>
        <el-form-item
          prop="plan_type">
          <v-select
            v-model="formData.plan_type"
            :list="plan_type_list"
            @change="changePlanType" />
        </el-form-item>
      </div>
      <template v-if="formData.plan_type == 4">
        <div class="form-item form-half">
          <span>Departure Date</span>
          <el-form-item
            prop="pcy_cmnt_dt">
            <v-date-picker
              v-model="formData.oneDayDate"
              type="date"
              :picker-options="oneDayPickerOptions"
              @change="handleDate">
            </v-date-picker>
          </el-form-item>
        </div>
      </template>
      <template v-if="formData.plan_type != 4">
        <div
          v-if="!isSinglePlan"
          class="flex-sb">
          <div class="form-item form-half">
            <span>Coverage</span>
            <el-form-item
              prop="area_of_travel">
              <v-radio-group
                v-model="formData.area_of_travel "
                block
                :list="area_of_travel_list" />
            </el-form-item>
          <!--          <p>age 18 -79</p>-->
          </div>

        </div>
        <div
          v-else
          class="form-item form-half">
          <span>Main Destination (Must be HK Departures)</span>
          <el-form-item
            prop="destination_id">
            <v-select
              v-model="formData.destination_id"
              :list="destiationList"
              :multiple-limit="10"
              :multiple="true"
            />
          </el-form-item>
        </div>
        <div
          v-if="formData.plan_type!=2"
          class="flex-sb">
          <div class="form-item form-half">
            <span>Departure and Return Date</span>
            <el-form-item
              prop="date">
              <v-date-picker
                v-model="formData.date"
                type="daterange"
                range-separator="-"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                :picker-options="pickerOptions"
                @change="handleDate">
              </v-date-picker>
            </el-form-item>
          </div>
        </div>
        <div
          v-if="formData.plan_type==2"
          class="flex-sb">
          <div class="form-item form-half">
            <span>Effective Date</span>
            <el-form-item
              ref="pcy_cmnt_dt"
              prop="pcy_cmnt_dt"
            >
              <v-date-picker
                v-model="formData.pcy_cmnt_dt"
                :picker-options="pickerOptions"
              >
              </v-date-picker>
            </el-form-item>
          </div>
        </div>
      </template>
      <div class="form-half form-item">
        <div class="form-item  button-popover">
          <span>No. of Traveller(s)</span>
          <el-form-item
            prop="person_form">
            <!--            <el-button v-popover:popover4>click 激活</el-button>-->
            <el-input
              v-popover:popover1
              :value="numOfTraveller"
              suffix-icon="el-icon-d-caret"
            >
            </el-input>
          </el-form-item>
          <!--          <p>family plan definition – If you select Family cover, the Policy covers you plus your spouse and children named in the Policy Schedule who travel with you for the entire journey on the same itinerary.</p>-->
        </div>
        <el-popover
          ref="popover1"
          v-model="visible"
          placement="bottom"
          width="360"
          trigger="click">
          <div
            v-if="formData.plan_type != 4"
            class="form-item form-half">
            <span>Cover Type</span>
            <el-form-item
              prop="class_type">
              <v-radio-group
                v-model="formData.class_type"
                block
                :list="class_type_list"
                @change="changeClassType" />
            </el-form-item>
            <!--          <p>family plan definition – If you select Family cover, the Policy covers you plus your spouse and children named in the Policy Schedule who travel with you for the entire journey on the same itinerary.</p>-->
          </div>
          <!--  4：One Day Local Tour，1：Single Plan - Return，3：Single Plan - One Way，2：Annual Plan-->
          <div
            v-if="isIndividual&&![1,2,3,4,5].includes(formData.plan_type)"
            class="flex-sb">
            <div class="form-item">
              <span>Number of Insured Person(s)</span>
              <el-form-item
                prop="no_of_traveler">
                <v-input-number
                  v-model="formData.no_of_traveler"
                  :max="travelerLimit.max"
                  :min="travelerLimit.min"/>
              </el-form-item>
              <!--          <p>age 18 -79</p>-->
            </div>

          </div>

          <div
            v-if="formData.class_type!==1|| [1,3,4,5,2].includes(formData.plan_type)"
          >
            <div
              class="form-item flex-sb-center"
            >
              <div class="form-item pd-b-0">
                <span>Elderly</span>
                <span class="tips fs-12 color-gray60">65 years old and above</span>
              </div>
              <el-form-item
                prop="no_of_adult">
                <v-input-number
                  v-model="formData.no_of_senior"
                  :max="seniorLimit.max"
                  :min="seniorLimit.min"
                  @blur="handleBlur"
                  @change="handleChangeNum"/>
              </el-form-item>
            </div>
            <div class="flex flex-senior ">
              <el-form-item
                v-for="(item,index) in formData.no_of_senior"
                :key="index"
                :ref="`senior_age_list.${index}`"
                class="width-100"
                :rules="rules.senior_age"
                :prop="`senior_age_list.${index}`">
                <v-select
                  v-model="formData.senior_age_list[index]"
                  placeholder="Age"
                  :list="senior_age"></v-select>
              </el-form-item>
            </div>
            <div
              class="form-item flex-sb-center"
            >
              <div class="form-item pd-b-0">
                <span>Adults</span>
                <span class="tips fs-12 color-gray60">18 years old and below 65</span>
              </div>
              <el-form-item
                prop="no_of_adult">
                <v-input-number
                  v-model="formData.no_of_adult"
                  :max="adultLimit.max"
                  :min="adultLimit.min"/>
              </el-form-item>
            </div>
            <div  class="form-item flex-sb-center"></div>
            <div
              v-if="!(isAnnual&&isIndividual)"
              class="form-item flex-sb-center">
              <div class="form-item pd-b-0">
                <span>Children</span>
                <span class="tips fs-12 color-gray60">Under 18 years old</span>
              </div>
              <el-form-item
                prop="no_of_child">
                <v-input-number
                  v-model="formData.no_of_child"
                  :min="childLimit.min"
                  :max="childLimit.max" />
              </el-form-item>
              <!--                  <p>age 0 - 17</p>-->
            </div>
          </div>
        </el-popover>
      </div>
      <!--      <div-->
      <!--        v-if="formData.plan_type!=2"-->
      <!--        class="flex-sb">-->
      <!--        <div class="form-item form-half">-->
      <!--          <span>Effective Date</span>-->
      <!--          <el-form-item-->
      <!--            prop="pcy_cmnt_dt">-->
      <!--            <v-date-picker-->
      <!--              v-model="formData.pcy_cmnt_dt" />-->
      <!--          </el-form-item>-->
      <!--        </div>-->
      <!--      </div>-->
      <!--      <div-->
      <!--        v-if="formData.plan_type!=2"-->
      <!--        class="flex-sb">-->

      <!--        <div class="form-item form-half">-->
      <!--          <span>End Date </span>-->
      <!--          <el-form-item-->
      <!--            prop="pcy_expry_dt">-->
      <!--            <v-date-picker-->
      <!--              v-model="formData.pcy_expry_dt"-->
      <!--              :disabled="!formData.pcy_cmnt_dt"-->
      <!--              :picker-options="formData.plan_type == 3? pickerOptions : null" />-->
      <!--          </el-form-item>-->
      <!--        </div>-->
      <!--      </div>-->

      <!--      <div-->
      <!--        v-if="isIndividual&&formData.plan_type!=2"-->
      <!--        class="flex-sb">-->
      <!--        <div class="form-item form-half">-->
      <!--          <span>Number of Traveller</span>-->
      <!--          <el-form-item-->
      <!--            prop="no_of_traveler">-->
      <!--            <v-select-->
      <!--              v-model="formData.no_of_traveler"-->
      <!--              :list="localAllOptions.traveler_num" />-->
      <!--          </el-form-item>-->
      <!--          &lt;!&ndash;          <p>age 18 -79</p>&ndash;&gt;-->
      <!--        </div>-->

      <!--      </div>-->

      <!--      <div-->
      <!--        v-if="formData.class_type!==1"-->
      <!--        class="form-item form-half"-->
      <!--      >-->
      <!--        <span>Number of Adult (For Spouse Only)</span>-->
      <!--        <el-form-item-->
      <!--          prop="no_of_adult">-->
      <!--          <v-select-->
      <!--            v-model="formData.no_of_adult"-->
      <!--            :list="localAllOptions.adult_num" />-->
      <!--        </el-form-item>-->
      <!--      </div>-->
      <!--      <div-->
      <!--        v-if="formData.class_type != 1"-->
      <!--        class="form-item form-half">-->
      <!--        <span>Number of Child </span>-->
      <!--        <el-form-item-->
      <!--          prop="no_of_child">-->
      <!--          <v-select-->
      <!--            v-model="formData.no_of_child"-->
      <!--            :list="localAllOptions.child_num" />-->
      <!--        </el-form-item>-->
      <!--        &lt;!&ndash;                  <p>age 0 - 17</p>&ndash;&gt;-->
      <!--      </div>-->
      <!--      <div class="flex-sb">-->
      <!--        <div class="form-item form-half">-->
      <!--          <span>Area of Travel</span>-->
      <!--          <el-form-item-->
      <!--            prop="area_of_travel">-->
      <!--            <v-select-->
      <!--              v-model="formData.area_of_travel "-->
      <!--              :list="localAllOptions.area_of_travel " />-->
      <!--          </el-form-item>-->
      <!--          &lt;!&ndash;          <p>age 18 -79</p>&ndash;&gt;-->
      <!--        </div>-->

      <!--      </div>-->
      <!-- <div
        v-if="isShowPlanLevel"
        class="form-item">
        <span>Plan Level</span>
        <el-form-item
          prop="plan_tier"
        >
          <v-radio-group
            v-model="formData.plan_tier"
            :border="true"
            :list="planLevelOptions"
          />
        </el-form-item>
      </div> -->

      <!--      <h3>More Benefits</h3>-->
      <!--      <div class="form-item">-->
      <!--        <el-form-item-->
      <!--          prop="benefits">-->
      <!--          <v-checkbox-group-->
      <!--            v-model="formData.benefits"-->
      <!--            :list="localAllOptions.benefits" />-->
      <!--        </el-form-item>-->
      <!--      </div>-->
      <div class="line-hr"></div>
      <div class="flex-sb">
        <div class="form-item form-half">
          <span>Special Activity Cover</span>
          <el-form-item>
            <v-checkbox-group
              v-model="formData.benefits "
              block
              :list="benefits(1)" />
          </el-form-item>
          <!--          <p>age 18 -79</p>-->
        </div>
      </div>
      <div class="line-hr mg-t-0"></div>
      <div class="flex-sb">
        <div class="form-item form-half">
          <span>Extra Protections</span>
          <el-form-item>
            <v-checkbox-group
              v-model="formData.benefits "
              block
              :list="benefits(2)" />
          </el-form-item>
          <!--          <p>age 18 -79</p>-->
        </div>
      </div>
    </el-form>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import dayjs from 'dayjs'

export default {
  name: 'TravelFormUnderwriting',
  mixins: [MixinOptions, MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    const check = (rule, value, callback) => {
      const valueResult = value !== null && value !== ''
      const { plan_type } = this.formData
      if( !valueResult) {
        callback(new Error(this.$t('placeholder.select')))
      }
      callback()
    }
    const checkStartDate = (rule, value, callback) => {
      const valueResult = value !== null && value !== ''
      let now_day = new Date()
      now_day = dayjs(now_day).format('YYYY-MM-DD')
      let differenct_day = dayjs(value).diff(dayjs(now_day),'day')
      const { plan_type } = this.formData
      if( !valueResult) {
        callback(new Error(this.$t('placeholder.select')))
      }
      if(plan_type==1&&differenct_day>45) {
        callback(new Error('單程旅遊開始日期必須在45天內'))
      }
      callback()
    }
    const checkEndDate = (rule, value, callback) => {
      const valueResult = value !== null && value !== ''
      const { plan_type,pcy_cmnt_dt } = this.formData
      let differenct_day = dayjs(value).diff(dayjs(pcy_cmnt_dt),'day')
      if( !valueResult) {
        callback(new Error(this.$t('placeholder.select')))
      }
      if(plan_type==1&&differenct_day>182) {
        callback(new Error('單程旅遊結束日期不得超過182天'))
      }
      callback()
    }
    const checkDate = (rule, value, callback) => {
      const valueResult = value !== null && value !== ''
      const { date=[] } = this.formData||{}
      if(date&&date.length<=0) {
        callback(new Error(this.$t('placeholder.select')))
      }
      callback()
    }
    const checkPeron = (rule, value, callback) => {
      const valueResult = value !== null && value !== ''
      const { class_type, no_of_traveler, no_of_adult, no_of_child,plan_type,no_of_senior,senior_age_list } = this.formData
      let peopleNum = this.isFamily||[1,3,4].includes(plan_type) ? (no_of_adult + no_of_child+no_of_senior) : no_of_traveler
      let travelers = Number(peopleNum)
      let adult = Number(no_of_adult) +  Number(no_of_senior)
      if(this.isIndividual&&adult<=0){
        callback(new Error(this.$t('placeholder.select')))
      }
      if(no_of_senior>0&&senior_age_list.length<=0){
        callback(new Error(this.$t('placeholder.select')))
      }
      if(!class_type||!travelers) {
        callback(new Error(this.$t('placeholder.select')))
      }
      callback()
    }
    const checkSeniorAge = (rule, value, callback) => {
      const field_arr = rule.field.split('.')||[]
      const index = field_arr[1]
      const { senior_age_list } = this.formData||{}
      if(!senior_age_list[index]){
        callback(new Error(this.$t('placeholder.select')))
      }
      callback()
    }
    return {
      formData: {
        class_id: 23,
        plan_type: '',
        pcy_cmnt_dt: '',
        pcy_expry_dt: '',
        destination_id: [],
        class_type: 1,
        no_of_traveler:'',
        no_of_child:0,
        area_of_travel :0,
        no_of_adult:0,
        no_of_senior:0,
        plan_tier: 0,
        benefits:[],
        date:[],
        senior_age_list:[],
        oneDayDate: ''
      },
      visible:false,
      extraRules: {
        date: [
          { validator: checkDate, trigger: ['change', 'blur'] }
        ],
        person_form:[
          { validator: checkPeron, trigger: ['change', 'blur'] }
        ],
        senior_age:[
          { validator: checkSeniorAge, trigger: ['change', 'blur'] }
        ]
        // pcy_expry_dt: [
        //   { validator: checkEndDate, trigger: ['change', 'blur'] }
        // ],
      },
      // pickerOptions: {
      //   disabledDate: (time) => {
      //     let start = dayjs(this.formData.pcy_cmnt_dt)
      //     let end = dayjs(time)
      //     // 结束日期大于开始日期7天或者小于开始日期就禁用
      //     return end.diff(start, 'day') >= 7 || end.diff(start, 'day') < 0
      //   },
      //   onPick:(time)=>{
      //     let start = dayjs(time.minDate)
      //     let end = dayjs(time.maxDate)
      //   }
      // }
    }
  },
  computed: {
    destiationList(){
      // let {area_of_travel} = this.formData||{}
      let {destinations=[] } = this.localAllOptions||{}
      // return destinations.filter(item=>item.type==area_of_travel||item.type==3)
      return destinations.filter(item=>{
        return item.type!=0
      })
    },
    isEasyGo(){
      let {plan_type} = this.formData||{}
      return plan_type == 5
    },
    area_of_travel_list(){
      let {area_of_travel=[]} = this.localAllOptions||{}
      if(this.isEasyGo){
        return area_of_travel.filter(item=>item.id==1)
      }
      return area_of_travel
    },
    class_type_list(){
      let {class_type=[]} = this.localAllOptions||{}
      if(this.isEasyGo){
        return class_type.filter(item=>item.id==1)
      }
      return class_type
    },
    rangeDay() {
      const { plan_type } = this.formData
      return plan_type == 3 ? 7 : 182
    },
    pickerOptions(){
      return{
        onPick: (obj) => {
          this.formData.pcy_cmnt_dt = new Date(obj.minDate).getTime()
          if(obj.maxDate){
            this.formData.pcy_expry_dt = dayjs(obj.maxDate).format('YYYY-MM-DD')
          }
        },
        disabledDate: (time) => {
          let today = dayjs()
          let end = dayjs(time)
          if(this.formData.pcy_cmnt_dt) {
            let start = dayjs(this.formData.pcy_cmnt_dt)
            // 结束日期大于开始日期7天或者小于开始日期就禁用
            const curtime = end.format('YYYY-MM-DD')
            const endDiff = end.diff(start, 'day')
            const mindate = start.subtract(this.rangeDay-1, 'day')
            const isBefore = dayjs(today).isBefore(mindate)
            const diffTime = isBefore ? mindate : today
            // start
            return endDiff >= this.rangeDay || end.diff(diffTime, 'day') < 0
          }else {
            return end.diff(today, 'day') < 0
          }
        },
      }
    },
    oneDayPickerOptions(){
      return{
        disabledDate: (time) => {
          let now = Date.now()
          let selectTime = time.getTime()
          let diff = (selectTime - now) / (3600 * 1000 * 24)
          return diff < 0 || diff > 45
        },
      }
    },
    localAllOptions() {
      return this.allOptions23
    },
    benefits(){
      return (index) =>{
        let {benefits=[]} = this.localAllOptions||{}
        return benefits.filter(item=>item.category==index)
      }
    },
    isShowPlanLevel(){
      const { area_of_travel } = this.formData
      return area_of_travel == 1 ? false : true
    },
    plan_type_list(){
      let arr =this.localAllOptions.plan_type.filter(item=>{
        return item.id==2
      })
      return this.formData.class_type==4?arr:this.localAllOptions.plan_type
    },
    isSinglePlan(){
      let {plan_type} = this.formData || {}
      return [1,3].includes(plan_type)//單次旅遊保障（單程&來回）
    },
    isIndividual(){
      let {class_type,plan_type} = this.formData
      // if(class_type==1)this.formData.no_of_traveler=1
      return class_type ==1
    },
    isAnnual(){
      let {class_type,plan_type} = this.formData
      // if(class_type==1)this.formData.no_of_traveler=1
      return plan_type ==2
    },
    adultNumOptions() {
      const { class_type,plan_type } = this.formData
      if ([1, 2].includes(Number(class_type))) {
        return this.localAllOptions.adult_num.filter((item) => item.id == 1)
      }
      return this.localAllOptions.adult_num
    },
    seniorNumOptions() {
      const { class_type,plan_type } = this.formData
      if ([1, 2].includes(Number(class_type))) {
        return this.localAllOptions.traveler_num
      }
      return this.localAllOptions.senior_num
    },
    seniorLimit() {
      let {plan_type,class_type,no_of_child=0,no_of_adult=0} = this.formData||{}
      let result = {
        min: 0,
        max: '',
      }
      if (this.seniorNumOptions) {
        const len = this.seniorNumOptions.length
        let max = this.seniorNumOptions[len - 1].id
        result.min = this.seniorNumOptions[0].id
        result.max = max - Number(no_of_adult)
      }
      // 一日游最大人数限制
      const people_max = this.localAllOptions.tp_one_day_tr_num

      if([4].includes(plan_type)){
        result.min = 0
        result.max = people_max - Number(no_of_child) - Number(no_of_adult)
      }
      if(class_type==1&&[1,3,5].includes(plan_type)){
        result.min = 0
        result.max = this.SingleIndividualTotal - Number(no_of_child) - Number(no_of_adult)
      }
      if(this.isIndividual&&this.isAnnual){
        result.min = 0
        result.max = 1 - Number(no_of_adult)
      }
      return result
    },
    adultLimit() {
      let {plan_type,class_type,no_of_child=0,no_of_senior} = this.formData||{}
      let result = {
        min: 0,
        max: '',
      }

      if (this.adultNumOptions) {
        const len = this.adultNumOptions.length
        let max = this.adultNumOptions[len - 1].id
        result.min = this.adultNumOptions[0].id
        result.max = max - Number(no_of_senior)
      }
      // 一日游最大人数限制
      const people_max = this.localAllOptions.tp_one_day_tr_num

      if([4].includes(plan_type)){
        // result.min = this.formData.no_of_child? 0 : 1
        result.min = 0
        result.max = people_max -  Number(no_of_child) - Number(no_of_senior)
      }
      if(class_type==1&&[1,3,5].includes(plan_type)){
        result.min = 0
        result.max = this.SingleIndividualTotal - Number(no_of_child) - Number(no_of_senior)
      }
      if(this.isIndividual&&this.isAnnual){
        result.min = 0
        result.max = 1 - Number(no_of_senior)
      }
      return result
    },
    childLimit() {
      let {plan_type,class_type,no_of_adult,no_of_senior} = this.formData||{}
      let result = {
        min: 0,
        max: '',
      }
      if (this.localAllOptions.child_num) {
        const { child_num = [] } = this.localAllOptions
        const len = child_num.length
        result.min = child_num[0].id
        result.max = child_num[len - 1].id
      }
      // 一日游最大人数限制
      const people_max = this.localAllOptions.tp_one_day_tr_num
      if(this.formData.plan_type == 4){
        // result.min = this.formData.no_of_adult? 0 : 1
        result.min = 0
        result.max = people_max  - Number(no_of_adult) - Number(no_of_senior)
      }
      if(class_type==1&&[1,3,5].includes(plan_type)){
        result.min = 0
        result.max = this.SingleIndividualTotal - Number(no_of_adult) - Number(no_of_senior)
      }
      if(this.isIndividual){
        result.max = 9
      }
      return result
    },
    travelerLimit() {
      let result = {
        min: 0,
        max: '',
      }
      if (this.localAllOptions.traveler_num) {
        const { traveler_num = [] } = this.localAllOptions
        const len = traveler_num.length
        result.min = traveler_num[0].id
        result.max = traveler_num[len - 1].id
      }
      return result
    },
    SingleIndividualTotal(){
      return 10
    },
    isFamily() {
      const { class_type } = this.formData
      return class_type == 3
    },
    numOfTraveller(){
      const { class_type, no_of_traveler, no_of_adult, no_of_child, plan_type,no_of_senior } = this.formData
      const optObj = this.localAllOptions
      let className = this.filterName(class_type,'id',optObj.class_type)

      let peopleNum = this.isFamily ? (no_of_adult + no_of_senior + no_of_child) : no_of_traveler
      let travelers = Number(peopleNum)

      const sign = 'Persons'
      const signAdult = 'Adult(s)'
      const signSenior = 'Elderly'
      const signChild = 'Child(ren)'
      let child = no_of_child?`${no_of_adult>0?'·':''} ${no_of_child} ${signChild}`:''
      let senior = no_of_senior?`${no_of_senior} ${signSenior} ${no_of_adult||no_of_child?' ·':''} `:''
      let adult = no_of_adult?`${no_of_adult} ${signAdult} `:''
      let all_text = `${senior} ${adult} ${child}`
      if([1,3,4,5].includes(plan_type)){
        this.formData.no_of_traveler = no_of_adult + no_of_child +no_of_senior
        return all_text
        // return no_of_child? `${no_of_senior} ${signSenior} · ${no_of_adult} ${signAdult} · ${no_of_child} ${signChild}` : `${no_of_senior} ${signSenior} · ${no_of_adult} ${signAdult}`
      }

      if(this.isFamily){
        return all_text
      }
      else if(this.isAnnual&&this.isIndividual){
        return all_text
      }
      else{
        return travelers?`${travelers} ${sign}`:''
      }
    },
    senior_age(){
      let {senior_single_age,senior_annual_age} = this.localAllOptions
      return this.isAnnual?senior_annual_age:senior_single_age
    }
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        Object.keys(this.formData).some(key => {
          if(key in val) {
            this.formData[key] = val[key]
          }
        })
      }
    },
    'formData.plan_type':{
      immediate: true,
      handler(val){
        if(val == 4){
          this.formData.class_type = 1
          this.formData.area_of_travel = 1
        }
      }
    },
    // isFamily:{
    //   immediate:true,
    //   handler(val){
    //     let {no_of_adult,no_of_child,no_of_senior} = this.formData
    //     if(val){
    //       this.formData.no_of_adult = no_of_adult?no_of_adult:2
    //       this.formData.no_of_child = no_of_child?no_of_child:1
    //     }else {
    //       this.formData.no_of_adult = no_of_adult?no_of_adult:1
    //       this.formData.no_of_child = no_of_child?no_of_child:0
    //       this.formData.no_of_senior = no_of_child?no_of_child:0
    //     }
    //   }
    // },
  },
  methods: {
    handleChangeNum(){
      let {no_of_senior,senior_age_list} = this.formData||{}
      if(no_of_senior==0)
        this.formData.senior_age_list = []
      else
        this.formData.senior_age_list = senior_age_list.slice(0,no_of_senior)||[]
    },
    handleBlur(){
      this.$refs.form.validate(valid => {})
    },
    handleDate(val){
      let oneDay = this.formData.plan_type == 4
      if(oneDay){
        this.formData.pcy_cmnt_dt = this.formData.pcy_expry_dt = val
      }else{
        if(val){
          this.formData.pcy_cmnt_dt = val[0]
          this.formData.pcy_expry_dt = val[1]
        }
        else {
          this.formData.date = []
        }
      }
    },
    filterName(val,key,list){
      let arr = list || []
      let res = arr.filter((v) => {
        return v[key] == val
      })
      if (res[0] && res[0].name) {
        return res[0].name
      }
      return ''
    },
    changeClassType() {
      this.formData.no_of_senior = 0
      this.formData.no_of_adult = 0
      this.formData.no_of_child = 0
      this.formData.senior_age_list = []
      this.$refs['form'].clearValidate(['no_of_child'])
    },
    submitForm() {
      // 表單校驗
      let {class_type, plan_type,no_of_adult,no_of_child,no_of_senior,senior_age_list} = this.formData
      if(class_type==1 && ![1,3,4,5].includes(plan_type))
      {
        delete  this.formData.no_of_child
        // delete  this.formData.no_of_adult
        // delete  this.formData.no_of_senior
        // delete  this.formData.senior_age_list
      }
      // if(class_type==3)
      // delete this.formData.no_of_traveler
      if(class_type!==1||[1,3,4,5].includes(plan_type)){
        this.formData.no_of_traveler = no_of_adult + no_of_child + no_of_senior
      }
      this.$refs.form.validate(valid => {
        if(valid) {
          let params = {
            ...this.formData,
            class_id: 23
          }
          if(!this.isShowPlanLevel){
            params.plan_tier = 0
          }
          this.$emit('getFormData', params)
        }
      })

    },
    changePlanType(){
      // this.formData.no_of_senior = 0
      // this.formData.no_of_adult = 0
      // this.formData.no_of_child = 0
      // this.formData.senior_age_list = []
      if(this.isAnnual&&this.isIndividual){
        this.formData.no_of_traveler = 1
      //   this.$refs['form'].clearValidate(['person_form'])
      }
      // this.formData.pcy_expry_dt = ''
      let today = dayjs().format('YYYY-MM-DD')
      // this.formData.date = [today,'']
    }
  }
}
</script>
<style lang="scss" scoped>
.flex-senior{
  margin-bottom: 16px;
  flex-wrap: wrap;
  /deep/.width-100{
    width: calc(25% - 4px);
    margin: 0px 2px 4px 2px !important;
  }
}
.form-underwriting {
  position: relative;
  // width: 700px;
  .tips{
    margin-bottom: 0;
  }

  width: 330px;
  .form-half{
    width: 330px;
  }
  p {
    padding-top: 5px;
    font-size: 16px;
    color: #616266;
  }
  .line-hr{
    margin-top: 14px;
    margin-bottom: 14px;
    height: 1px;
    background: #D1D5DA;
    &.mg-t-0{
      margin-top: 0;
    }
  }
  /deep/.button-popover{
    .el-input.is-disabled .el-input__inner{
      background-color: white!important;

    }
    .el-input__inner{
      height: 32px;
    }
    .el-input__suffix{
      line-height: 24px;
    }
    .el-input__icon{
      line-height: 26px;
    }
  }
  /deep/ .el-date-editor{
    width: 100%;
    line-height: 32px;
    height: 32px;
    .el-range-separator,.el-range__icon,.el-range__close-icon{
      line-height: 24px;
    }
    .el-input__inner{
      height: 100%;
    }
    .el-input__icon{
      line-height: 1;
    }
  }
}
</style>
